<kui-card>
    <kui-card-body>
        @if (data.editorAction === "zoneedit") {
            <div class="heading" [ngClass]="{ compact: compact }">
                <kui-icon color="default" class="mr-3" [size]="compact ? 'sm' : 'lg'" name="edit"> </kui-icon>
                <h5 class="m-0">
                    {{ "LEAFLET.DRAW.DRAG_HANDLES" | translate }}
                </h5>
            </div>
            @if (form$ | async; as zoneForm) {
                <key-form-builder [inline]="false" [form]="zoneForm.form" [values]="zoneForm.values"> </key-form-builder>
                <div class="d-flex">
                    <button class="mr-1 mt-1" kui-button (click)="save(data.zoneId, zoneForm.values)">
                        {{ "LEAFLET.DRAW.SAVE" | translate }}
                    </button>
                    <button class="mr-1 mt-1" kui-button color="secondary" (click)="cancel()">
                        {{ "LEAFLET.DRAW.CANCEL" | translate }}
                    </button>
                    <button class="mr-1 mt-1" kui-button color="secondary" (click)="delete()">
                        {{ "SHARED.DELETE" | translate }}
                    </button>
                </div>
            } @else {
                <div class="d-flex justify-content-center align-item-center m-5">
                    <kui-loader size="medium"></kui-loader>
                </div>
            }
        } @else {
            @if (zoneCreated$ | async; as zoneCreationEvent) {
                @if (form$ | async; as zoneForm) {
                    <key-form-builder [inline]="false" [form]="zoneForm.form" [values]="zoneForm.values"> </key-form-builder>
                    <button kui-button (click)="createNew(zoneForm.values, zoneCreationEvent.points)">
                        {{ "LEAFLET.DRAW.FINISH" | translate }}
                    </button>
                    <button kui-button color="secondary" (click)="cancel()">
                        {{ "LEAFLET.DRAW.CANCEL" | translate }}
                    </button>
                } @else {
                    <div class="d-flex justify-content-center align-item-center m-5">
                        <kui-loader size="medium"></kui-loader>
                    </div>
                }
            } @else {
                <div class="heading" [ngClass]="{ compact: compact }">
                    <kui-icon color="default" class="mr-3" [size]="compact ? 'sm' : 'lg'" [name]="data.editorAction === 'zoneaddpolygon' ? 'draw-polygon' : 'pen-line'"> </kui-icon>
                    <h5 class="m-0">
                        {{ "LEAFLET.DRAW.DRAG_HANDLES" | translate }}
                    </h5>
                </div>
                <button kui-button (click)="finishDrawing()">
                    {{ "LEAFLET.DRAW.FINISH_DRAWING" | translate }}
                </button>
                <button kui-button color="secondary" (click)="removeLastPoint()">
                    {{ "LEAFLET.DRAW.DELETE_LAST_POINT" | translate }}
                </button>
                <button kui-button color="secondary" (click)="cancel()">
                    {{ "LEAFLET.DRAW.CANCEL" | translate }}
                </button>
            }
        }
    </kui-card-body>
</kui-card>
